import React from 'react'
import { StyledButton } from './style.js'

const Button = (props) => {
    return (
        <StyledButton {...props}/> 
    )
}       

export default Button